import {
  confirmPasswordReset,
  signInWithEmailAndPassword,
} from "firebase/auth";

import { AppDispatch } from "../../store";
import { auth } from "../../firebaseConfig";
import { sessionLoginThunk } from "../../store/slices/userThunks";

function generateCSRFToken() {
  return [...Array(32)].map(() => Math.random().toString(36)[2]).join("");
}

export function login(email: string, pass: string, dispatch: AppDispatch) {
  return signInWithEmailAndPassword(auth, email, pass).then(
    (userCredential) => {
      //
      console.log({ userCredential });

      return userCredential.user.getIdToken().then((idToken) => {
        const csrfToken = generateCSRFToken();
        document.cookie = `loa-csrf=${csrfToken}; secure; sameSite=strict; path=/`;
        //const csrfToken = getCookie("csrfToken");
        dispatch(sessionLoginThunk({ email, idToken, csrfToken }));
      });
    }
  );
}

export function logout() {
  return auth.signOut().then(() => {
    // Clear the cookie
    document.cookie =
      "loa-csrf=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.assign("/login");
    // window.location.reload();
  });
}

export function resetPassword(oobCode: string | null, pass: string) {
  if (!!oobCode) {
    return confirmPasswordReset(auth, oobCode, pass);
  }
  return Promise.reject("No oobCode");
}

type LoginMode =
  | "set"
  | "reset"
  | "resetPassword"
  | "request"
  | "create"
  | "login";

type ItemStatus = "virgin" | "good" | "bad";

export interface LoginStatus {
  name: ItemStatus;
  email: ItemStatus;
  pass: ItemStatus;
  verify: ItemStatus;
}

export interface LoginValues {
  name: string;
  email: string;
  pass: string;
  verify: string;
}

export function checkStatus(values: LoginValues): LoginStatus {
  const hasPass = !!values.pass && !!values.verify; //??
  const hasEmail = !!values.email;
  return {
    name: !!values.name ? "good" : "virgin",
    email: hasEmail
      ? !!values.email?.match(/.+@.+\..+/)
        ? "good"
        : "bad"
      : "virgin",
    pass: hasPass ? "good" : "virgin",
    verify: hasPass
      ? values.pass === values.verify
        ? "good"
        : "bad"
      : "virgin",
  };
}
